import { useEffect, useState } from 'react';
import { getPayoutAccount } from 'api/paymentSetup';
import { PayoutAccount } from 'types/paymentSetup';

export const usePayoutAccount = (): [PayoutAccount, boolean, () => void] => {
    const [loading, setLoading] = useState(false);
    const [serviceData, setServiceData] = useState<PayoutAccount>({});

    const fetchData = async () => {
        try {
            setLoading(true);
            const result = await getPayoutAccount();
            if (!result.error) {
                const data: PayoutAccount = result?.data?.data || {};
                setServiceData(data);
            }
            setLoading(false);
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchData();
    }, []);

    return [serviceData, loading, fetchData];
};
